import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import {ApModalService} from 'webcommon/core-ui';
import { ApCustomDateRange } from 'webcommon/shared';
import { ApTimeSpanSelectorModalComponent } from './ap-timespan-selector-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ApTimeSpanSelectorModalService {
  constructor(private apModalService: ApModalService) { }

  openModal(baseId: string): Observable<ApCustomDateRange> {

    const initialState = {
      baseId,
    };
    const p = this.apModalService.showComponentModal(ApTimeSpanSelectorModalComponent, {
      panelClass: 'modal-sm',
      disableClose: true,
      initialState,
    });
    return from(p);
  }
}
